import { useMarketingCookies } from '@/hooks/useMarketingCookies';
import { ensureLeadId } from '@/lib/ensureLeadId';
import { getReferrer } from '@/utils/referrer';
import { useCallback, useState } from 'react';
import { StateChangeParams, useStateChangeTrackingMutation } from './api';

export const useStateChangeTracking = () => {
  const { marketingCookies } = useMarketingCookies();

  const [error, setError] = useState(null);

  const { mutateAsync, isPending } = useStateChangeTrackingMutation();
  const track = useCallback(
    async ({ source, stateInformation, payload }: StateChangeParams) => {
      const cookiesPayload = marketingCookies;

      const leadId = payload?.leadId || (await ensureLeadId());

      if (!cookiesPayload) return;

      const referrer = getReferrer();

      const mutationPayload: StateChangeParams = {
        source,
        stateInformation,
        payload: {
          ...cookiesPayload,
          ...payload,
          ...(referrer ? { referrer } : {}),
          leadId,
        },
      };

      return mutateAsync(mutationPayload).catch(error => {
        setError(error);
      });
    },
    [marketingCookies, mutateAsync]
  );

  return { track, loading: isPending, error };
};
